<div class="microphone-required" role="alertdialog" aria-labelledby="microphone-required-title" aria-describedby="microphone-required-summary">
  <mat-icon class="microphone-required__icon">mic_off</mat-icon>

  <h1 mat-dialog-title id="microphone-required-title" class="microphone-required__title">{{ help.title }}</h1>

  <div mat-dialog-content>
    <p id="microphone-required-summary" class="microphone-required__summary">{{ help.summary }}</p>

    <ol class="microphone-required__steps">
      <li *ngFor="let step of help.steps">{{ step }}</li>
    </ol>

    <p class="microphone-required__still-unavailable" *ngIf="stillUnavailable" role="status">
      The microphone is still not available. Check the steps above and try again.
    </p>
  </div>

  <div mat-dialog-actions class="microphone-required__actions">
    <button mat-button type="button" (click)="notNow()">Not now</button>
    <button mat-raised-button color="primary" type="button" (click)="tryAgain()" [disabled]="checking" cdkFocusInitial>
      <mat-spinner *ngIf="checking" [diameter]="20" class="microphone-required__spinner"></mat-spinner>
      <ng-container *ngIf="!checking">Try again</ng-container>
    </button>
  </div>
</div>
